import InfoDialog from "./infoDialog.container";

export default InfoDialog;
